/* eslint-disable */
import React from 'react';
import { EyeInvisibleOutlined, EyeOutlined, WalletOutlined, DollarCircleOutlined } from '@ant-design/icons';
import { Card, CardProps, Typography } from 'antd';
import Utils from 'src/utils';

interface IWalletBalanceProps extends CardProps {
  value?: number | null;
  title: string;
  // optional icon chip shown next to the title - omit to keep the plain title (unused elsewhere, but kept optional so nothing breaks if left off)
  variant?: 'wallet' | 'commission';
}

const variantIcon = {
  wallet: <WalletOutlined />,
  commission: <DollarCircleOutlined />,
};

const WalletBalance = (props: IWalletBalanceProps) => {
  const [hide, setHide] = React.useState(true);

  const titleNode = props.variant ? (
    <span className="d-flex align-items-center">
      <span className={`hd-card-icon ${props.variant}`}>{variantIcon[props.variant]}</span>
      {props.title}
    </span>
  ) : (
    props.title
  );

  return (
    <Card
      styles={{
        header: {
          margin: 0,
          paddingBottom: 0,
          fontSize: '14px',
          fontWeight: 'lighter',
        },
      }}
      title={titleNode}
      className="relative"
      loading={props.loading}
      bodyStyle={{ paddingTop: 0 }}
      style={{ height: '109.9px' }}
    >
      {hide ? (
        <EyeInvisibleOutlined
          className="position-absolute"
          onClick={() => setHide((prev) => !prev)}
          style={{ right: '1rem', top: '1rem', fontSize: '24px' }}
        />
      ) : (
        <EyeOutlined
          className="position-absolute"
          onClick={() => setHide((prev) => !prev)}
          style={{ right: '1rem', top: '1rem', fontSize: '24px' }}
        />
      )}
      <Typography.Title className="m-0">
        {hide ? '*** *** ***' : `${Utils.Money(!props.value ? 0 : props?.value)}`}
      </Typography.Title>
    </Card>
  );
};

export default React.memo(WalletBalance);
